/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

export default safeGet;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/_safeGet.js
// module id = 449
// module chunks = 0